var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typewriter"},[(!_vm.displayText)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),(_vm.displayText)?[_c('span',[_vm._v(_vm._s(_vm.displayText))]),(_vm.showCursor)?_c('span',{staticClass:"cursor"},[_vm._v("|")]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }